import { render } from "./DicomOption.vue?vue&type=template&id=32f9f8ba&scoped=true&ts=true"
import script from "./DicomOption.vue?vue&type=script&lang=ts"
export * from "./DicomOption.vue?vue&type=script&lang=ts"

import "./DicomOption.vue?vue&type=style&index=0&id=32f9f8ba&scoped=true&lang=css"
import "./DicomOption.vue?vue&type=style&index=1&id=32f9f8ba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f9f8ba"]])

export default __exports__